import { bool, func } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import { salesChannelsEnum } from '../../../opportunities/constants';
import { opportunityShape } from '../../../prop-types';
import withApiRequest from '../../../REST/with-api-request';
import { addInvoice } from '../../actions/invoice-actions';
import { allStatusesEnum } from '../../constants';
import { getAccountSfIdForInvoice, getInvoiceBillingType } from '../../utils';
import { transformForPatch } from '../transform-invoice-helpers';

class CreateInvoiceButton extends React.Component {
  handleCreateInvoice = () => {
    const { opportunity, onRequest, onAdd, onSuccess } = this.props;
    const { primaryQuote, salesChannel } = opportunity;
    const isSelfService = salesChannel === salesChannelsEnum.SELF_SERVICE;
    const accountSfId = getAccountSfIdForInvoice(opportunity);
    const defaultInvoiceType = 'Manual';
    const newInvoice = transformForPatch({
      opportunity,
      opportunityId: opportunity.id,
      bookingEntries: [],
      accountSfId,
      status: allStatusesEnum.DRAFT.value,
      billingType: getInvoiceBillingType(opportunity, accountSfId),
      type: defaultInvoiceType,
      salesChannel,
      purchaseOrderNumber: isSelfService
        ? ''
        : primaryQuote.purchaseOrderNumber,
    });
    onRequest(onAdd, newInvoice).then(onSuccess);
  };

  render() {
    const { loading, disabled } = this.props;
    return (
      <Button disabled={loading || disabled} onClick={this.handleCreateInvoice}>
        Create Invoice
      </Button>
    );
  }
}

CreateInvoiceButton.propTypes = {
  opportunity: opportunityShape.isRequired,
  loading: bool.isRequired,
  onRequest: func.isRequired,
  onAdd: func.isRequired,
  onSuccess: func.isRequired,
  disabled: bool,
};

CreateInvoiceButton.defaultProps = {
  disabled: false,
};

const WrappedCreateInvoiceButtonWithLoader = withApiRequest({
  query: (onAdd, invoice) => onAdd(invoice),
})(CreateInvoiceButton);

export default connect(null, { onAdd: addInvoice })(
  WrappedCreateInvoiceButtonWithLoader,
);
